import { FC, useContext } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { Box } from '@mui/system';

import { routes } from '../../constants/routes';
import { AuthContext } from '../../providers/auth-context';
import { DualOccupantLoginForm } from '../../features/dual-occupant-login/dual-occupant-login-form';

import { styles } from './styles';
import { OccupantDetailsContainer } from './occupant-details-container';

export const OccupantDetailsPage: FC = () => {
    const userState = useContext(AuthContext);
    const [searchParams] = useSearchParams();

    const vitaRef = searchParams.get('ref');
    const user = searchParams.get('u');
    const pin = searchParams.get('pin');

    if (!vitaRef || !user || !pin) return <Navigate to={routes.failure.index} />;

    const userEmail = atob(user);
    const userLoggedIn = userState.loggedIn;

    if (!userLoggedIn) {
        return (
            <Box css={styles.layout}>
                <Box css={styles.leftSide}>
                    <DualOccupantLoginForm email={userEmail} pin={pin} />
                </Box>
            </Box>
        );
    }

    return (
        <Box css={styles.layout}>
            <Box css={styles.leftSide}>
                <OccupantDetailsContainer vitaRef={vitaRef} userSession={userState.session} />
            </Box>
        </Box>
    );
};
